// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { Body, Card, LgPadding } from '@alto/design-system';
import React from 'react';
import { PageBackground, SingleColumnContentWrapper } from '~web/components/Page';

export const ContactRequestedPage = () => {
  return (
    <PageBackground>
      <SingleColumnContentWrapper>
        <Card title="Thank you!">
          <LgPadding topPadding={SPACING.STATIC.NONE}>
            <Body>Thanks for your interest. Someone from our team will be in touch shortly.</Body>
          </LgPadding>
        </Card>
      </SingleColumnContentWrapper>
    </PageBackground>
  );
};
